export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_535b6642260e6e766d51c4bf